// import { useStore } from "store";
import {
  useToast
} from "@chakra-ui/react";
import useAuth from "hooks/useAuth";
import Pusher from "pusher-js";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useOnScreen } from "./useOnScreen";
export const toastStatuses = {
  info: "info",
  error: "error",
  success: "success",
  warning: "Warning"
}

export default function useInlineWebPush(userData, skip) {
  const { token, isSignedIn } = useAuth();
  const onScreen = useOnScreen();
  const pusherStream = useRef({});
  const toast = useToast();

  const webNotify = useCallback((data)=> {
    if (window.Notification && Notification.permission === "granted") {
      var i = 0;
      // Using an interval cause some browsers (including Firefox) are blocking notifications if there are too much in a certain time.
      var interval = window.setInterval(function () {
        new Notification(data.title, {tag: data?.tag || 'notification'});
        if (i++ === 9) {
          window.clearInterval(interval);
        }
      }, 200);
    }

    // If the user hasn't told if they want to be notified or not
    // Note: because of Chrome, we are not sure the permission property
    // is set, therefore it's unsafe to check for the "default" value.
    else if (window.Notification && Notification.permission !== "denied") {
      Notification.requestPermission(function (status) {
        // If the user said okay
        if (status === "granted") {
          var i = 0;
          var interval = window.setInterval(function () {
            new Notification(data.title, {tag: data?.tag || 'notification'});
            if (i++ === 9) {
              window.clearInterval(interval);
            }
          }, 200);
        }

        // Otherwise, we can fallback to a regular modal alert
        else {
          toast(data);
        }
      });
    }
    // If the user refuses to get notified
    else {
      // We can fallback to a regular modal alert
      toast(data);
    }
  }, [toast])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const showNotif = (data) => {
    const toastIt = 2 + 2 === 4;
    if(toastIt) {
      toast({
        position: "top",
        title: data?.title || "New Update",
        description: data?.message || "",
        status: toastStatuses[data.status] || "info",
        variant: "top-accent",
        duration: 9000,
        isClosable: true,
      });
    } else { // because this dude is unstable
      webNotify({
        position: "top",
        title: data?.title || "New Update",
        description: data?.message || "",
        status: toastStatuses[data.status] || "info",
        variant: "top-accent",
        duration: 9000,
        isClosable: true,
      });
    }
  }
 
  const pusherSelfHandler = useMemo(() => ({
    pushNotification: {
      register: isSignedIn || onScreen,
      do: showNotif,
    },
    testEvent: {
      register: isSignedIn || onScreen,
      do: showNotif,
    }
  }), [isSignedIn, showNotif, onScreen])

  const pusherGlobalHandler = pusherSelfHandler;

  const initPusherAuth = async(channelName, handlers, endpoint) => {
    if (!pusherStream.current[channelName]) {
      const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
        authEndpoint: `${process.env.REACT_APP_API_ENDPOINT}/${endpoint}`,
        cluster: process.env.REACT_APP_PUSHER_CLUSTER,
        auth: {
          params: { channelName },
          headers: { authorization: token },
        },
      });
      const currentSub = pusher.subscribe(channelName)
      pusherStream.current = {...pusherStream.current, [channelName]: currentSub};

      const binders = Object.keys(handlers);
      binders.forEach((binding) => {
        if(handlers[binding]?.register) {
          pusherStream?.current[channelName]?.bind(binding, handlers[binding]?.do)
        }
      })
    }  else {
      console.log({pusherStream})
    }
  };
  
  useEffect(() => {
    if(!skip) {
      if(isSignedIn && userData) {
      const selfChannel = userData?.userId || userData?._id
      const globalChannel = "all-users"
        initPusherAuth(selfChannel, pusherSelfHandler, "realtime/self/auth")
        initPusherAuth(globalChannel, pusherGlobalHandler, "realtime/global/auth")
      }
    }
    return () => {
      const bindings = Object.keys(pusherStream.current);
      bindings.forEach((binding) => {
        pusherStream.current[binding] && pusherStream.current[binding].unsubscribe(binding);
      })
      pusherStream.current = {}
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip, isSignedIn, userData])
}
